import { render, staticRenderFns } from "./ChooseTownDialog.vue?vue&type=template&id=40896882&"
import script from "./ChooseTownDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChooseTownDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40896882')) {
      api.createRecord('40896882', component.options)
    } else {
      api.reload('40896882', component.options)
    }
    module.hot.accept("./ChooseTownDialog.vue?vue&type=template&id=40896882&", function () {
      api.rerender('40896882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/ChooseTownDialog/ChooseTownDialog.vue"
export default component.exports